import * as React from 'react';
import { Box, Collapse, Divider, List } from '@mui/material';
import ListItemButton from '../ListItemButton';
import { NavProps } from '../data';

interface Props {
  item: NavProps;
  selectedIndex: number;
  subItemSelectedIndex: number;
  handleSelect: Function;
  handleSubItemSelect: Function;
}

export default function ListItemLink({
  item,
  selectedIndex,
  subItemSelectedIndex,
  handleSelect,
  handleSubItemSelect,
}: Props) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (item.id === selectedIndex) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [item.id, selectedIndex]);

  const handleOpening = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment key={item.id}>
      <ListItemButton
        isLink={false}
        open={open}
        item={item}
        selected={item.id === selectedIndex}
        handleClick={() => {
          handleOpening();
          handleSelect(item.id);
        }}
      />
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense disablePadding sx={{ maxHeight: 200, overflowY: 'auto' }}>
          {item.subItems &&
            item.subItems.map((subItem) => {
              return (
                <Box sx={{ display: 'flex', alignItems: 'center' }} key={subItem.id}>
                  <Divider orientation="vertical" flexItem sx={{ bgcolor: 'lightGrey', ml: 4 }} />
                  <ListItemButton
                    isLink={true}
                    open={false}
                    item={subItem}
                    key={subItem.id}
                    selected={subItem.id === subItemSelectedIndex}
                    handleClick={() => {
                      handleSubItemSelect(subItem.id);
                      handleSelect(item.id);
                    }}
                    isSubItem={true}
                  />
                </Box>
              );
            })}
        </List>
      </Collapse>
    </React.Fragment>
  );
}
